import BaseClient from '@/app/model/api/response/baseApiClient'

class FieldListApi extends BaseClient {
  public getFieldData (flag: boolean, type: string, data: any) {
    const path = '/v1/field/list'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params

    if (flag) {
      params = new URLSearchParams({ is_plant: '0' })
    } else {
      params = new URLSearchParams({ is_plant: '1' })
    }

    // スマホかWebか判定
    if (type === '0') {
      params.append('request_type', '0')
      params.append('is_polygon', '1')
      params.append('accordion_id', '1')
    } else {
      params.append('request_type', '1')
      params.append('is_polygon', '1')
      params.append('is_field', data.is_field)
      params.append('order_num', data.order_num)

      if (data.order_num === 1) {
        params.append('field_point_lat', data.field_point_lat)
        params.append('field_point_lng', data.field_point_lng)
      }

      if (data.word !== '') {
        params.append('word', data.word)
      }
      if (data.variety_id !== 0) {
        params.append('variety_id', data.variety_id)
      }
      if (data.grade_id !== 0) {
        params.append('grade_id', data.grade_id)
      }
      if (data.growth_stage_id !== 0) {
        params.append('growth_stage_id', data.growth_stage_id)
      }
      if (data.risk_id !== 0) {
        params.append('risk_id', data.risk_id)
      }
      if (data.planting_id !== undefined) {
        params.append('planting_id', data.planting_id)
      }
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new FieldListApi()
